import cn from 'classnames';
import { Loader } from '../Loader';
import styles from './PageLoader.module.scss';

interface PageLoaderProps {
  className?: string;
}

export const PageLoader = ({ className }: PageLoaderProps) => (
  <div className={cn(styles.root, className)}>
    <Loader />
  </div>
);
